export default __webpack_public_path__ + "fonts/c85efd8adc626e2e8a22c874334e9298.svg";